export default "__VITE_ASSET__DqDDw$hY__"